// import { logoutApi, loginApi } from "actions/public";
import React, { createContext, useContext, useEffect, useState } from "react";
import * as api from "../API/index";
import { ROLES } from "variables/constants";
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({
    name: null,
    email: null,
    role: null,
    token: null,
  });

  const [loading, setLoading] = useState(true);

  // Restore session
  useEffect(() => {
    const stored = localStorage.getItem("p");
    if (stored) {
      setAuth(JSON.parse(stored));
    }
    setLoading(false);
  }, []);

  // const login = async (loginData) => {
  //   const res = await login(loginData);

  //   if (res?.status === "SUCCESS") {
  //     setAuth(res.data);
  //     localStorage.setItem("p", JSON.stringify(res.data));

  //     return { success: true };
  //   }

  //   return { success: false, message: res?.message };
  // };

  const login = async (loginData) => {
    try {
      const res = await api.user_login(loginData);
      if (res?.data?.status === "SUCCESS") {
        const userData = {
          ...res.data?.data,
        };
        setAuth(userData);
        localStorage.setItem("p", JSON.stringify(userData));

        return { success: true };
      }

      return { success: false, message: res?.message };
    } catch (error) {
      return error?.response?.data;
    }
  };

  // const logout = async () => {
  //   await logoutApi();
  //   setAuth({ name: null, email: null, role: null, token: null });
  //   localStorage.removeItem("p");
  // };

  const logout = async () => {
    try {
      await api.user_logout();
    } catch (error) {
      return error?.response?.data;
    } finally {
      setAuth({ name: null, email: null, role: null, token: null });
      localStorage.removeItem("p");
    }
  };

  return (
    <AuthContext.Provider
      value={{
        ...auth,
        isAuthenticated: !!auth.token,
        login,
        logout,
        loading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
